import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../index-B0Q3DaKR.js';
import { _ as _defineProperty } from '../defineProperty-DmV7cVMj.js';
import { _ as _slicedToArray } from '../slicedToArray-DvtHmgP0.js';
import fetch from 'isomorphic-fetch';
import { getCookie } from '../cookie/index.js';
import LRU from '../LRUCache/index.js';
import { CURRENT_LANGUAGE_COOKIE_NAME, LANGUAGE_HEADER_KEY } from '../configs/constants/index.js';
import IS_BROWSER from '../isBrowser/index.js';
import getDeviceId from '../getDeviceId/index.js';
import RequestStore from '../RequestStore/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var lruCache = new LRU(50);
var makeUnique = function makeUnique(url, method, data) {
  return "".concat(url, "-").concat(method, "-").concat(data);
};
var getRequestOptions = function getRequestOptions(options) {
  var myHeaders = new Headers();
  options.headers && Object.entries(options.headers).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return myHeaders.append(key, value);
  });
  return _objectSpread(_objectSpread({}, options), {}, {
    headers: myHeaders
  });
};
var getDeviceIdAndLanguage = function getDeviceIdAndLanguage(device, language) {
  return _objectSpread(_objectSpread({}, device && getDeviceId() && {
    deviceId: getDeviceId()
  }), language && _defineProperty({}, LANGUAGE_HEADER_KEY, getCookie(CURRENT_LANGUAGE_COOKIE_NAME)));
};
var getHeaders = function getHeaders(initialHeaders, options) {
  return {
    headers: _objectSpread(_objectSpread({}, initialHeaders), options === null || options === undefined ? undefined : options.headers)
  };
};
var getOptions = function getOptions(initialHeaders, options, withDeviceId, withLanguageHeader) {
  return _objectSpread(_objectSpread(_objectSpread({}, options), getHeaders(initialHeaders || {}, options)), getDeviceIdAndLanguage(withDeviceId, withLanguageHeader));
};
var getFromCache = function getFromCache(hash) {
  return lruCache.read(hash);
};
var cacheResults = function cacheResults(res, useCache, hash) {
  if (res.status === 200 && useCache) {
    lruCache.set(hash, res);
  }
};
var handleRequest = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options) {
    var useCache,
      hash,
      _RequestStore$get,
      request,
      _result,
      result,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          useCache = _args.length > 2 && _args[2] !== undefined ? _args[2] : true;
          hash = makeUnique(url, options.method || 'GET', options);
          if (!(useCache && lruCache.has(hash))) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", getFromCache(hash));
        case 4:
          if (!IS_BROWSER) {
            _context.next = 13;
            break;
          }
          request = (_RequestStore$get = RequestStore.get(hash)) !== null && _RequestStore$get !== undefined ? _RequestStore$get : fetch(url, getRequestOptions(options));
          RequestStore.set(hash, request);
          _context.next = 9;
          return request;
        case 9:
          _result = _context.sent;
          RequestStore.drop(hash);
          cacheResults(_result, useCache, hash);
          return _context.abrupt("return", _result);
        case 13:
          _context.next = 15;
          return fetch(url, getRequestOptions(options));
        case 15:
          result = _context.sent;
          return _context.abrupt("return", result);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleRequest(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();
function fetchFactory(configs) {
  var baseUrl = configs.baseUrl,
    cacheEnabled = configs.withCache,
    headers = configs.headers,
    withDeviceId = configs.withDeviceId,
    withLanguageHeader = configs.withLanguageHeader;
  return function (url, options, withCache) {
    return handleRequest("".concat(baseUrl).concat(url), getOptions(headers, options, withDeviceId, withLanguageHeader), withCache !== null && withCache !== undefined ? withCache : cacheEnabled);
  };
}

export { fetchFactory as default };
//# sourceMappingURL=index.js.map
